// extracted by mini-css-extract-plugin
module.exports = {"root":"header_root__kBrmE","title":"header_title__w4FTp","icon":"header_icon__2lGsc","head":"header_head__3-qnM","text":"header_text__2m69-"};